<p-confirmDialog key="edit" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>

<!--Menu-->
<div class="MainGrid2Col">
	<label>Student ID:</label>
	<label>{{ StudentID }}</label>

	<label>Student Name:</label>
	<label>{{ StudentName }}</label>

	<label>Section:</label>
	<label>{{ Section }}</label>

	<label>Date/Time:</label>
	<label>{{ DateTime }}</label>

	<label>Status:</label>
	<select class="form-control" [(ngModel)]="ClassAttendanceStatusID" (ngModelChange)="onStatusChange($event)">
		<option *ngFor="let o of lstClassAttendanceStatus" [ngValue]="o.ClassAttendanceStatusID">
			{{ o.ClassAttendanceStatusDesc }}
		</option>
	</select>

	<label>Excuse:</label>
	<select [disabled]="DisableExcuse() == true" class="form-control" [(ngModel)]="ClassAttendanceExcuseID">
		<option *ngFor="let o of lstClassAttendanceExcuse" [ngValue]="o.ClassAttendanceExcuseID">
			{{ o.ClassAttendanceExcuseDESC }}
		</option>
	</select>
</div>

<!--Buttons-->
<div class="Buttons">
	<button class="btn btn-primary" (click)="onUpdate()">Update</button>
	<button class="btn btn-primary" (click)="onClose()">Close</button>
</div>
